export default {
  name: 'AsMap',
  props: {
    id: { type: String, default: () => (`a-s-map-${Math.random().toString().substring(2)}`) },
    url: { type: String, default: () => 'https://map.sgcc.com.cn/maps?v=3.0.0' },
    appKey: { type: String, default: () => '63d56e0db9803597854d0aecee9275b8' },
    appSecret: { type: String, default: () => '1c2ebbcc96dd30d9b025d41e423dd7d7' },
    appStyle: { type: String, default: () => 'aegis://styles/aegis/Streets-v2' },
    zoom: { type: Number | String, default: () => 11 },
    center: { type: Array, default: () => [116.397428, 39.90923] },
    localIdeographFontFamily: { type: String, default: () => 'Microsoft YoHei' },
  },
  data() {
    return ({
      scriptId: `script-${this.id}`,
      map: null,
      loading: false,
    });
  },
  created() {
    this.create();
  },
  destroyed() {
    this.cancel();
  },
  methods: {
    onload(url, callback = null) {
      let script = document.createElement('script');
      script.id = this.scriptId;
      script.src = url;
      if (callback) {
        script.onload = script.onreadystatechange = () => {
          if (!script.readyState || (script.readyState == 'loaded' || script.readyState == 'complete')) {
            callback();
            script.onreadystatechange = null;
            script.onload = null;
          }
        };
      }
      let head = document.querySelector('head');
      head && (head.appendChild(script));
    },
    create() {
      this.loading = true;
      this.onload(this.url, () => {
        if (SGMap) {
          // 申请的key和sn
          SGMap.tokenTask.login(this.appKey, this.appSecret).then(() => {
            // 1. 新版底图只支持SDK 3.0.0 以上版本使用，低于 3.0.0 版本请使用 Streets 底图样式
            // 2. 如果访问Streets-v2底图提示没有数据权限，请使用Streets底图样式
            this.map = new SGMap.Map({
              // 地图绑定的DOM元素ID
              container: this.id,
              // 地图样式
              style: this.appStyle,
              // 默认缩放层级
              zoom: this.zoom,
              // 地图中心点
              center: this.center,
              // 地图默认字体
              localIdeographFontFamily: this.localIdeographFontFamily,
            });
            this.loading = false;
          });
        }
      });
    },
    cancel() {
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }
      let headLink = document.head.lastChild;
      if (headLink && (headLink.nodeName == 'LINK')) {
        headLink.remove();
      }
      this.$nextTick(() => {
        let headScript = document.getElementById(this.scriptId);
        if (headScript) headScript.remove();
      });
    },
  },
  render() {
    const { width = '100%', height = '100%' } = this.$attrs;
    return (<div id={this.id} class="a-s-map" v-loading={this.loading} style={{ width, height }} />);
  },
}